import type { IxcPortfolioV1SweepBalanceKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const getPortfolioSweepBalancePath: EntityPathBuilder<IxcPortfolioV1SweepBalanceKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return undefined;
    case 'detail': {
      if (!context?.keys?.assetId) {
        return undefined;
      }

      return getResolvedPath('/registration/account/$accountId/cash/sweep/$assetId', context.keys);
    }
  }
};

export function getPortfolioSweepBalanceDetailPath(accountId: string | undefined, assetId: string | undefined) {
  if (!accountId || !assetId) {
    return undefined;
  }

  return getPortfolioSweepBalancePath({ kind: 'detail', keys: { accountId, assetId } });
}
